import {useAppSelector} from "../../../../../../redux/hooks";
import {
  getMySongsPageSelectedSongPreviewModalContent,
  getMySongsPageSongSelectedSongDetailsLessonPreviewSheetMusicUrlByLessonId,
  getMySongsPageSongSelectedSongDetailsLessonPreviewWistiaVideoIdByLessonId
} from "../../../../modules/my-songs-page-store/mySongsPage.selectors";
import {isDefined} from "../../../../../../util/is-type";
import {mySongsPageStore} from "../../../../modules/my-songs-page-store/mySongsPage.store";
import {useSongDetailsDisplaySelectedLesson} from "../../hooks/useSongDetailsDisplaySelectedLesson";

export interface ISongDetailsLessonPreviewModalLogic {
  isDisplayed: boolean;
  previewContent?: 'video' | 'sheetMusic';
  closeModalHandler: () => void;

  previewWistiaVideoId?: string;
  previewSheetMusicUrl?: string;
}

export const useSongDetailsLessonPreviewModalLogic = (): ISongDetailsLessonPreviewModalLogic => {
  const {lessonId, firstLessonId} = useSongDetailsDisplaySelectedLesson();

  const activeLessonId =lessonId ?? firstLessonId ?? 0;

  const previewContent = useAppSelector(getMySongsPageSelectedSongPreviewModalContent);
  const previewSheetMusicUrl  = useAppSelector((store) => getMySongsPageSongSelectedSongDetailsLessonPreviewSheetMusicUrlByLessonId(store, activeLessonId));
  const previewWistiaVideoId  = useAppSelector((store) => getMySongsPageSongSelectedSongDetailsLessonPreviewWistiaVideoIdByLessonId(store, activeLessonId));
  const isDisplayed = isDefined(previewContent);

  return {
    isDisplayed,
    previewContent,
    closeModalHandler: () => mySongsPageStore.closeSongDetailsPreviewModal(),
    previewSheetMusicUrl,
    previewWistiaVideoId,
  };
}
